import { useState } from "react";
import { toast } from "sonner";
import { Lock, Delete } from "lucide-react";
import { api, apiError } from "@/lib/api";

export const PinScreen = ({ onSuccess }) => {
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (fullPin) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/pin", { pin: fullPin });
      sessionStorage.setItem("bliss_admin_token", r.data.token);
      toast.success("Accesso effettuato");
      onSuccess();
    } catch (e) {
      toast.error(apiError(e));
      setPin("");
    } finally {
      setLoading(false);
    }
  };

  const press = (d) => {
    if (loading) return;
    const next = pin + d;
    setPin(next);
    if (next.length === 4) submit(next);
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex flex-col items-center justify-center px-4">
      <img src="/logo.png" alt="Bliss Café" className="h-16 w-auto mb-6" />
      <div className="w-14 h-14 rounded-full bg-[#C85A32] flex items-center justify-center mb-4">
        <Lock className="w-7 h-7 text-white" />
      </div>
      <h1 className="font-display text-2xl font-bold text-white mb-1">Area riservata</h1>
      <p className="text-sm text-slate-400 mb-8">Inserisci il PIN a 4 cifre</p>
      <div data-testid="admin-pin-input" className="flex gap-3 mb-8">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`w-4 h-4 rounded-full border-2 ${pin.length > i ? "bg-[#C85A32] border-[#C85A32]" : "border-slate-600"}`} />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-3">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((d) => (
          <button key={d} data-testid={`pin-key-${d}`} onClick={() => press(d)}
            className="w-16 h-16 rounded-full bg-[#1E293B] text-white text-xl font-bold hover:bg-[#C85A32] transition-colors">
            {d}
          </button>
        ))}
        <div />
        <button data-testid="pin-key-0" onClick={() => press("0")} className="w-16 h-16 rounded-full bg-[#1E293B] text-white text-xl font-bold hover:bg-[#C85A32] transition-colors">0</button>
        <button data-testid="pin-key-delete" onClick={() => setPin(pin.slice(0, -1))} className="w-16 h-16 rounded-full text-slate-400 hover:text-white flex items-center justify-center">
          <Delete className="w-6 h-6" />
        </button>
      </div>
      {loading && <p className="text-xs text-slate-500 mt-6">Verifica in corso…</p>}
    </div>
  );
};
